import { render } from "./StockDashboard.vue?vue&type=template&id=fc681768"
import script from "./StockDashboard.vue?vue&type=script&lang=js"
export * from "./StockDashboard.vue?vue&type=script&lang=js"

import "./StockDashboard.vue?vue&type=style&index=0&id=fc681768&lang=css"
script.render = render

export default script